import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import moment from 'moment';
import { Accordion, AccordionTab } from 'primereact/accordion';
import readXlsxFile from 'read-excel-file';
import UploadImage from '../../../assets/images/uploadImg.svg';
import lodash from 'lodash';
import Attachments from '../../../shared/UI/Attachments/Attachments'; 
import * as XLSX from 'xlsx';

const Inputs = ({ field, metaData, onInputChange, ...props }) => {
    const type = props.match.params.type;
    const Component = ImplementationFor[field.fieldType] || false;
    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={Object.assign({}, { ...metaData }, { 'Employees': type === 'edit' ? props.keywordValuesList : props.EmployeeList.map(el => Object.assign({}, { label: el.employeeName, value: el.employeeId, id: parseInt(el.employeeNo) })) }, { 'Requested For': type === 'edit' ? props.keywordValuesList : props.EmployeeList.map(el => Object.assign({}, { label: el.employeeName, value: el.employeeId, id: parseInt(el.employeeNo) })) })}
    /> || null;

}

const WORK_SCHEDULE_ID = 'db4bccf0-4446-464e-ba88-28991bd6acec';

const WEEK_DAY = [{ label: 'sun', value: 0 }, { label: 'mon', value: 1 }, { label: 'tue', value: 2 }, { label: 'wed', value: 3 }, { label: 'thu', value: 4 }, { label: 'fri', value: 5 }, { label: 'sat', value: 6 }];

let timeSheetData = []

class ShiftApproval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timesheetEmpData: [],
            timesheetShiftData: [],
            timesheetPreview: false,
            processInitiated: null,
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            stageSequence: 0,
            fromDate: false,
            toDate: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            error: false,
            RequestedFor: this.props.loggedUserDetail.empID,
            requestedFor: this.props.loggedUserDetail.empID,
            EmployeeList: false,
            popupType: 'submit',
            dialogBoxText:"",
            timesheetForm:[
                ['AL', 'Annual Leave', 'SKL', 'Sick Leave', 'CO', 'Compensatory OFF', 'UL', 'Unpaid Leave'],
                ['EL', 'Emergency Leave', 'WI', 'Working Injury Leave', 'EXL', 'Examination Leave', 'ML', 'Marraige Leave'],
                ['CL', 'Child Birth Leave', 'DL', 'Death Leave', 'HL', 'Hajj Leave', 'BT', 'Business Trip'],
                ['TR', 'Training', 'SL', 'Sport Leave', 'G', 'General(7:30am - 4:00pm)', 'M', 'Morning Shift(7:00am - 3:00pm)'],
                ['E', 'Evening Shift(3:00am - 11:00pm)', 'N', 'Night Shift(11pm - 7am)', 'TM', 'Twelve Morning(7:00 am - 7:00 pm)', 'TE', 'Twelve Evening(7:00 pm - 7:00 am)'],
                ['GC', 'General Conir(7:00am - 5:00pm)', 'MC', 'Morning Shift Conir(7:00am - 5:00pm)', 'EC', 'Evening Shift Conir(1:00 pm - 11:00 pm)', 'NC', 'Night Shift Conir(9:00 pm - 7:00 am)'],
                ['SD', 'Security Day(06:00 to 18:00)', 'SN', 'Security Night(18:00 to 06:00)', 'SM', 'Security Morning(1:00 pm - 11:00 pm)', 'NC', 'Night Shift Conir(9:00 pm - 7:00 am)'],
                ['GS', 'General HR(07:30 - 5:30)', 'QD', 'Quality Day(06:00AM - 06:00PM)', 'QN', 'Quality Night(06:00PM - 06:00 AM)', 'S1', 'Shift 1(7:00 am - 1:00 pm)'],
                ['s2', 'Shift 2(01:00pm - 07:00 pm)', 'S3', 'Shift 3(07:00pm - 01:00am)', 'S4', 'Shift 4(01:00am - 07:00 am)', 'OT1', 'OT1'],
                ['Shrt', 'Short Hrs', 'Reg', 'Regular']
            ],
            activeIndex: false,
            requestattachments: [],
            employees: false,
            processInitiated: false,
            OTHours: false,
            CostCenter: false, 
            OrgUnit: false, 
            Project: false,
            Remark: false,
            employees: false,
            requestDate: false,
            Shift: false,
        }
        this.initialize = this.initialize.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this); 
        this.readFromExcel = this.readFromExcel.bind(this);
    }


    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value,type, checked } = e.target;
        const { shiftPatternData } = this.props;
        const { fromDate, toDate, requestedFor, stageSequence, process, initialData,Shift } = this.state;


        if(name ==='00100100002' || name ==='00100100003' ){
            this.setState({processInitiated: false})
        }// to hide the preview button if the requested for or from date or to date is changed
        let selEmployees = el.fieldDescription === 'Employees' && value || [];
        let selShift = el.fieldDescription === 'Shift Pattern' && shiftPatternData && shiftPatternData.length > 0 && shiftPatternData.find(_ => parseInt(_.id) === parseInt(value)) || false;
        let startDate = fromDate && moment(fromDate);
        let selDay = false;
        let selIndex = 0;
        let shiftIndex = 1;
        let shift = false;
        let changedValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
            stage_Field: stage
                .stage_Field.map(field => {
                    let EmployeeId = null;
                    startDate = field.fieldDescription === 'Date' && moment(field.fieldValue) || moment(startDate);
                    selDay = WEEK_DAY.find(_ => parseInt(_.value) === parseInt(startDate.day()));
                    if (el.fieldDescription === 'Shift Pattern' && field.fieldDescription === 'Shift') {
                        shift = shiftIndex === 0 ? selShift.xoffShift : selShift.xonShift;
                        if (parseInt(selShift.xon) === selIndex && shiftIndex === 1) {
                            shiftIndex = 0;
                        //    selIndex = 0;
                        } else if (parseInt(selShift.xoff) === selIndex && shiftIndex === 0) {
                            shiftIndex = 1;
                           // selIndex = 0;
                        }
                        //selIndex++;
                    }

                    if (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') {
                        if (parseInt(selIndex) === selEmployees.length) {
                            selIndex = 0;
                        }
                        EmployeeId = selEmployees && selEmployees.length > 0 && selEmployees[selIndex] || null;
                        selIndex++;
                    }

             //       const fieldValue = (field.fieldName === name) || (el.fieldDescription === 'Shift' && field.fieldDescription === 'Shift' && el.parentFieldId === '000') ? value : (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') ? EmployeeId : (el.fieldDescription === 'Cost Center' && field.fieldDescription === 'Cost Center' && el.parentFieldId === '000') ? value :(field.fieldDescription === "Employees" && el.fieldDescription === 'Employees') ? value.map(c => c).join(','): (el.fieldDescription === 'Project' && field.fieldDescription === 'Project' && el.parentFieldId === '000') ? value : (el.fieldDescription === 'Shift Pattern' && field.fieldDescription === 'Shift' && selDay && !selShift.xbyx && selShift[selDay.label]) ? selShift[selDay.label].toString() : (el.fieldDescription === 'Shift Pattern' && field.fieldDescription === 'Shift' && selShift.xbyx && shift) ? shift.toString() : field.fieldValue;
                    // return Object.assign({}, { ...field }, { fieldValue })
                    return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === "Employee Id" && el.fieldDescription === 'Employees') ? EmployeeId : (el.fieldDescription === 'Shift' && field.fieldDescription === 'Shift' && el.parentFieldId === '000') ? value :(field.fieldDescription === "Cost Center" && el.fieldDescription === 'Cost Center' && el.parentFieldId === '000') ? value : (type === 'checkbox' && field.fieldName === name) ? checked: (field.fieldDescription === "Employees" && el.fieldDescription === 'Employees') ? value.map(c => c).join(',') : field.fieldName === name ? value : (el.fieldDescription === 'Project' && field.fieldDescription === 'Project' && el.parentFieldId === '000') ? value : (el.fieldDescription === 'Shift Pattern' && field.fieldDescription === 'Shift' && selDay && !selShift.xbyx && selShift[selDay.label]) ? selShift[selDay.label].toString() : (el.fieldDescription === 'Shift Pattern' && field.fieldDescription === 'Shift' && selShift.xbyx && shift) ? shift.toString()  : field.fieldValue })

                })
        }));

        this.setState({
            fromDate: el.fieldDescription === 'From Date' ? value : fromDate,
            toDate: el.fieldDescription === 'To Date' ? value : toDate,
            employees: el.fieldDescription === "Employees" ? value.map(c => c).join(',') : this.state.employees,
            Project: el.fieldDescription === "Project" ? value : this.state.Project,
            OrgUnit: el.fieldDescription === "Cost Center" ? value : this.state.OrgUnit,
            Shift: el.fieldDescription === "Shift" ? value : this.state.Shift,
            Remark:el.fieldDescription === "Remark" ? value : this.state.Remark,
            requestedFor: el.fieldDescription === 'Requested For' ? value : requestedFor,
            process: changedValues,
        });
// COMMENTED BY ABU 16 NOV 2024
        // if (el.fieldDescription === 'Requested For') {
        //     this.setState({ loading: true });
        //     setTimeout(() => this.initialize(initialData, 'request'), 3000);
        // }
// END COMMENT

    }

    initialize = (process, type) => {
        const { tableLists, shiftPatternData, location = {} } = this.props;
        const { stageSequence, fromDate, toDate, requestedFor, employees,Project,CostCenter,OTHours,OrgUnit,Shift } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status);
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;        
       
        if(type == 'progress'){
            this.setState({processInitiated: true})
        } 
        if(type == 'add'){
            this.setState({processInitiated: false})
        } 

        let count = 1;
        let sequence = 1;
        let start = moment(fromDate);
        let end = moment(toDate);
        if ((type === 'progress' && fromDate && toDate && employees && start <= end) || type === 'add' || type === 'edit' || type === 'request') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if ((type === 'add' && stageIndex === 0 && (el.fieldDescription === "From Date" ||el.fieldDescription === "To Date" ||el.fieldDescription === "Cost Center" || el.fieldDescription === "Project" || el.fieldDescription === "Employees" || el.fieldDescription === "Requested For" || el.fieldDescription === "Shift" || el.fieldDescription ===   "Shift Pattern") ) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:false});
                        } else if ((type === 'request' && stageIndex === 0 && (el.fieldDescription === "Requested For" || el.fieldDescription === "From Date" || el.fieldDescription === "To Date")) || (type === 'add' && stageIndex > 0)) {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldValue: (el.fieldDescription === 'Requested For' && requestedFor) || el.fieldValue, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'progress' && el.fieldType === '9') {
                            let startDate = moment(fromDate);
                            let endDate = moment(toDate);
                            let totalDays = endDate.diff(startDate, 'days');

                                // let selEmployee = requestedFor && EmployeeList && EmployeeList.length > 0 && EmployeeList.find(_ => _.employeeId === requestedFor) || false;
                                  const container = stageField.find(_ => _.fieldType === '9');
                                const name = container.fieldName;
                                const fields = stageField.filter(_ => _.parentFieldId === name);
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                const lastItem = a[a.length - 1];
                                let selEmployees = employees.split(',');
                                if (selEmployees && selEmployees.length > 0) {
                                    let loopIndex = 0;
                                    selEmployees.map(sel => {
                                let selShift = sel && sel.defaultShiftPatternid && shiftPatternData && shiftPatternData.length > 0 && shiftPatternData.find(_ => _.id === sel.defaultShiftPatternid) || false;

                                    let startDate = moment(fromDate);
                                    let endDate = moment(toDate);
                                if (fromDate && toDate && startDate <= endDate) {
                                    let loopIndex = 0;
                                    while (startDate <= endDate) {
                                        let formatDate = new Date(startDate);
                                        // let selIndex = 1;
                                        // let shiftIndex = 1;
                                         let shift = false;
                                        fields.map((subField) => {
                                            // if (subField.fieldDescription === 'Shift') {
                                            //     shift = shiftIndex === 0 ? selShift.xoffShift : selShift.xonShift;
                                            //     if (parseInt(selShift.xon) === selIndex && shiftIndex === 1) {
                                            //         shiftIndex = 0;
                                            //         selIndex = 0;
                                            //     } else if (parseInt(selShift.xoff) === selIndex && shiftIndex === 0) {
                                            //         shiftIndex = 1;
                                            //         selIndex = 0;
                                            //     }
                                            //     selIndex++;

                                            // }

                                            const selDay = WEEK_DAY.find(_ => parseInt(_.value) === parseInt(startDate.day()));
                                            const fieldValue = (subField.fieldDescription === 'Date' && formatDate) ||(subField.fieldDescription === 'Project' && Project) ||  (subField.fieldDescription === 'Employees' && sel) || (subField.fieldDescription === 'Employee Id' && sel) || (subField.fieldDescription === 'Cost Center' && OrgUnit) || (subField.fieldDescription === 'Shift' && Shift ) || null;
                                        a.push(Object.assign({}, { ...subField },
                                            {
                                                childRowNmbr: loopIndex,
                                                fieldName: `${startIndex}${count++}`,
                                                fieldSequence: sequence++,
                                                groupingfieldvalue: sel,
                                                fieldValue, 
                                                stageSequence: stageIndex, 
                                                stageNum: `00${stageIndex}`,
                                                parentFieldId: lastItem.fieldName
                                            }));
                                        });
                                        loopIndex++;
                                        startDate.add(1, 'days');
                                       //  startDate.setDate(startDate.getDate() + 1);
                                    }
                                    }
                                });
                            }
                            this.setState({processInitiated:true});
                        } else if (type === 'progress' && el.parentFieldId === '000') {
                            // commented by abu 16 nov 2024
                            //let selEmployee =employees && employees.length > 0 && employees.find(_ => _.employeeId === requestedFor) || false;
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === 'From Date' && fromDate) || (el.fieldDescription === 'To Date' && toDate) || (el.fieldDescription === "Project" && Project) || (el.fieldDescription === "Cost Center" && OrgUnit) || (el.fieldDescription === "Shift" && Shift) ||(el.fieldDescription === 'Requested For' && requestedFor) || (el.fieldDescription === 'Shift Pattern' && employees && parseInt(employees.defaultShiftPatternid)) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            // end comment
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === 'From Date' && fromDate) || (el.fieldDescription === 'Requested For' && requestedFor) || (el.fieldDescription === 'To Date' && toDate) || el.fieldValue, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName  }));
                                        })
                                    }
                                })
                            }
                            this.setState({processInitiated:true});
                        }  else if(type === "bulkUpload"){
                            
                        }
                        return a;
                    }, [])
                })
            });
            if (InitialValues && InitialValues.length > 0)
                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
           // setTimeout(this.handleExcel.bind(this), 5000);
        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Select From Date and To Date' });
        }

    }

    // to show the preview of the applied work schedule as requested by customer
    showPreview() {
        const { process } = this.state;

        let  a = (this.props.loggedUserDetail!==null) ? [{label: `${this.props.loggedUserDetail.userName}(Self)`, value: this.props.loggedUserDetail.empID, id: this.props.loggedUserDetail.userID, nationality: this.props.loggedUserDetail.nationality}].concat(this.props.subordinatesListData) : this.props.subordinatesListData;


        // finding the requested for, from date, to date for the timesheet data api

        let RequestedFor = '';
        let FromDate = '';
        let ToDate = '';

        process.map((stage, stageindex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'Requested For') {
                    let RequestedForEmp = a.filter((emp) =>{
                        return emp.value === el.fieldValue
                    })
                    RequestedFor = (RequestedForEmp[0].id || RequestedForEmp[0].userId )
                } else if (el.fieldDescription === 'From Date') {
                    FromDate = el.fieldValue;
                } else if (el.fieldDescription === 'To Date') {
                    ToDate = el.fieldValue;
                } else if(el.fieldDescription === 'Comment' && stageindex === 0){
                    Comment = el.fieldValue;
                }
            })
        });

        // if(RequestedFor == null || undefined){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Requested For before PreViewing' })
        //     return
        // }
        if(FromDate == null || undefined){
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Select From Date For before PreViewing' })
            return
        }
        if(ToDate == null || undefined){
            this.growl.show({ severity: 'error', summary: null, detail: 'Please Select To Date before PreViewing' })
            return
        }    
        let month = FromDate.getMonth() + 1
        let year = FromDate.getFullYear()
        let lastDay = ''
        let noOfDays = () => { 
            return lastDay = new Date(year, month, 0).getDate(); 
        }
        let employeeId= RequestedFor;
        let generate= true; 
        let fromDate= new Date(year, month - 1, 1);
        let toDate= new Date(year, month, lastDay);  
        

        if (employeeId && fromDate && toDate) {
            this.setState({loading:true});
            axios.get(`/master/api/GetEmployeeWorkSheetDetails?EmployeeId=${employeeId}&FromDate=${moment(fromDate).format('YYYY-MM-DD')}&ToDate=${moment(toDate).format('YYYY-MM-DD')}&generate=${generate}`)
                .then(response => {
                    if (response.status === 200) {
                        if(response.data == null || undefined){
                            this.growl.show({severity: 'error', summary: null, detail: 'No Data returned from API'})
                            return
                        }
                        timeSheetData = response.data
                        this.setState({
                                       timesheetEmpData:timeSheetData.Table, //emplyee data from timesheet api
                                       timesheetShiftData:timeSheetData.Table1 //shift details from time sheet api
                                    })
                        this.setState({loading:false});
                        this.setState({timesheetPreview: true})
                        // dispatch(fetchEmployeeWorkSheetSuccess(response && response.data || {}));
                    }
                })
                .catch(err => {
                    this.setState({loading:false});
                    this.growl.show({severity: 'error', summary: null, detail:'Fetch API Error'})
                })
        } else {
            this.setState({loading:false});
            this.growl.show({severity: 'error', summary: null, detail: 'Please provide correct details'});
        }  
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process,processInitiated } = this.state;
        const type = this.props.match.params.type;

        // if(!processInitiated){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please Initiate before Submitting/Saving' });
        //     this.setState({ loading: false })
        //     return;
        // }

        let RequestedFor = '';
        let FromDate = '';
        let ToDate = '';
        let Comment = '';
        let RequestAttributes = [];
        process.map((stage, stageindex) => {
            stage.stage_Field.map(el => {
                if (el.fieldDescription === 'Requested For') {
                    RequestedFor = el.fieldValue;
                } else if (el.fieldDescription === 'From Date') {
                    FromDate = el.fieldValue;
                } else if (el.fieldDescription === 'To Date') {
                    ToDate = el.fieldValue;
                } else if(el.fieldDescription === 'Comment' && stageindex === 0){
                    Comment = el.fieldValue;
                }
                
                RequestAttributes.push(Object.assign({}, {...el}, {fieldValue: (el.fieldType === "7" || el.fieldType === "8" || (el.fieldType === "1" && el.fieldStatus === "Display Only")) ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue}));
            })
        });

        //Checking if all the fields are not empty
        if(submitType === 'submit'){
            // if (!RequestedFor){
            //     this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Requested For Before submitting' })
            //     return  
            // }
            if (!FromDate){
                this.growl.show({ severity: 'error', summary: null, detail: 'Please Select From Date Before submitting' })
                return 
            }
            if (!ToDate){
                this.growl.show({ severity: 'error', summary: null, detail: 'Please Select To Date Before submitting' })
                return 
            }
            let a = false
            // process.map((stage, stageindex) => {
            //     stage.stage_Field.map(el => {
            //         if (el.fieldDescription === 'Shift' || el.fieldDescription === 'Shift Pattern') {
            //             if(!el.fieldValue){
            //                 this.growl.show({ severity: 'error', summary: null, detail: 'Please Enter Valid Shift Or Valid Shift Pattern' })
            //                 return a = true 
            //             }
            //         }                    
                    
            //     })
            // });
            if(a){
                return
            }
        }



        let data = {
            FromDate: FromDate,
            ToDate: ToDate,
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Work Schedule Request',
            IsActive: true,
            RequestDate: new Date(),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor:  this.props.loggedUserDetail.empID,
            ProcessID: WORK_SCHEDULE_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: [],
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'WorkSchedule';
            }

            if(submitType === 'delegate'){
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.Request_WF_LEVEL_ID || '';
                model = 'WorkSchedule';
            } 
            
            if(submitType === 'forward'){
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.Request_WF_LEVEL_ID || '';
                model = 'WorkSchedule';
            } 
            
            if(submitType === 'return' && this.state.DynamicSupervisor){
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.Request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
                model = 'WorkSchedule';
            }

            if (submitType === 'cancel') {
                model = 'WorkSchedule';
            }


            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if(submitType === 'reject'){
                url = '/master/api/workflow/reject?type=' + model;
            } else if(submitType === 'delegate'){
                url = '/master/api/workflow/delegate?type=' + model;
            } else if(submitType === 'forward'){
                url = '/master/api/workflow/forward?type=' + model;
            } else if(submitType === 'return'){
                url = '/master/api/workflow/return?type=' + model;
            } else if(submitType === 'cancel'){
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });
           
            axios.post(url, JSON.stringify(datas))
                .then(response => {
     
                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Work Schedule request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Work Schedule request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: err && err.response && err.response.data || 'Submit Failed' });
                })

        }

    }

    componentDidMount() {
        const { getContainerData, getMasterKeywordList, getKeywordValues, loggedUserDetail, getShiftPatternData,fetchSubordinatesLists, location = {} } = this.props;
        const type = this.props.match.params.type;
        this.setState({processInitiated:false})
        getContainerData(WORK_SCHEDULE_ID);//Get Container Data
        getMasterKeywordList('Shift');// Get Shift Dropdown list
        getMasterKeywordList('Project');// Get Shift Dropdown list
        getMasterKeywordList('CostCenter');// Get Shift Dropdown list
        getMasterKeywordList('OrgUnit')
        getKeywordValues('Employee');//Get Employee Dropdown list
       // getKeywordValues('OrgUnit');//Get Org Unit Dropdown list
        getShiftPatternData();
        fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId)

        axios.get(`/master/api/GetEmployeeListWorkSchedule?EmployeeId=${loggedUserDetail.empID}`)
            .then(response => {
                if (response.status === 200) {
                    this.setState({ EmployeeList: response.data })
                }
            })
            .catch(err => {
                this.setState({ error: 'Employee List Api Error', EmployeeList: [] })
            })

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading && this.state.EmployeeList) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length-1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);
        

    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [], subordinatesListData: [] })
    }



    downloadOtTemplate = () => {
            const process = this.state.process;
            const stage_Field = process[0].stage_Field;
        
            const Fromdate = stage_Field.find(field => field.fieldId === "6988f945-d667-4ae7-9631-4a2af16302ac");
            const Todate = stage_Field.find(field => field.fieldId === "31f907c9-91e6-446a-aafa-301daf59973b");
        
            // Parse the Fromdate and Todate into Date objects
            const fromDate = Fromdate.fieldValue ? new Date(Fromdate.fieldValue) : null;
            const toDate = Todate.fieldValue ? new Date(Todate.fieldValue) : null;
        
            const employees = stage_Field.find(field => field.fieldId === "1d46b0a0-be23-4283-ab73-eda3c9fbf323");
        
            let missingFields = [];
            if (!fromDate) missingFields.push('From Date');
            if (!toDate) missingFields.push('To Date');
            if (!employees.fieldValue) missingFields.push('Employees');
        
            if (missingFields.length > 0) {
                this.growl.show({
                    severity: 'error',
                    summary: null,
                    detail: `The following fields are missing: ${missingFields.join(', ')}.`
                });
                return;
            }
    
        
            const employeeList = employees.fieldValue.split(',');
        
            const project = stage_Field.find(field => field.fieldId === "1cfc5fec-7a4e-4152-8204-d05b671a6d8e").fieldValue;
            const orgUnit = stage_Field.find(field => field.fieldId === "1cfc5fec-7a4e-4152-8204-d05b671a5d8e").fieldValue;
    
            const propsEmployee = this.props.metaData.Employees;
            const propsProject = this.props.metaData.Project;
            const propsOrgUnit = this.props.metaData["Cost Center"];
        
            const employeeObject = {};
            employeeList.forEach((value, index) => {
                employeeObject[index] = value;
            });
        
            const employeesArray = [];
            Object.values(employeeObject).forEach(employeeValue => {
                propsEmployee.forEach(employee => {
                    if (employee.value === employeeValue) {
                        employeesArray.push([employee.label, employee.id]);
                    }
                });
            });
        
            let Project = "";
            propsProject.forEach(proj => {
                if (proj.value === project) {
                    Project = proj.id;
                }
            });
    
            let OrgUnit = "";
            propsOrgUnit.forEach(cc => {
                if (cc.value === orgUnit) {
                    OrgUnit = cc.label;
                }
            });
        
            // Define the columns for the Excel file
            const columns = ['Employee Code', 'Name', 'Cost Center', 'Project', 'Remark', 'Month', 'Year'];
        
            //dynamic date columns between Fromdate and Todate
            let currentDate = new Date(fromDate);
            const dateColumns = [];
            while (currentDate <= toDate) {
                dateColumns.push(currentDate.getDate()); // Add day of the month
                currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
            }
        
            // const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        
            const data = employeesArray.map(employee => [
                employee[1],
                employee[0],
                OrgUnit ? OrgUnit : "",
                Project ? Project : "",
                '',
                toDate.getMonth()+1 ,
                toDate.getFullYear(),
                ...Array(dateColumns.length).fill('')
            ]);
        
            // Combine header and data
            const sheetData = [
                [...columns, ...dateColumns], // Header row
                ...data // Data rows
            ];
        
           // Create a worksheet and a workbook
            const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "WS Template");
        
            // Export the Excel file
            XLSX.writeFile(workbook, 'WS_Template.xlsx');
        }

    handleMethods(type){
        this.setState({popupType: type });
        const { keywordValuesList } = this.props;
        this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
    }
    handleTabChange(e) {
        this.setState({ loading: true, activeIndex: e.index })
        setTimeout(() => this.setState({ loading: false }), 3000);
    }

    // componentWillUnmount() {
    //     const { clearCacheStorage } = this.props;
    //     clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, shiftPatternData: [], keywordValuesList:[] })
    // }
    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet,childRowNmbr) {
        
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr  ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }
    readFromExcel = (vals, process) => {
        const input = document.getElementById('bulkUploadFile');
        if (input){
        const { stageSequence, requestDate, employees, OTHours, otType,workorderno,Reason,CostCenter,Project,Remark,OrgUnit} = this.state;
        let {  fromDate, toDate} = this.state;
        
        const { keywordValuesList: empList,metaData} = this.props;


        let count = 1;
        let sequence = 1;
        
        let empOtData = [] // contains an arry of obj with each obj having empid empname month of the ot year of the ot and hour for each specific day at "hours" key
           let costcentlist = metaData["Cost Center"];
            let projectlist = metaData["Project"]
        readXlsxFile(input.files[0]).then((otData) => {
            let InvalidEmployees = []; // Track skipped employee IDs

            let otDays = otData[0].slice(7)
            var monthc = "";
            otData.forEach((row, rowIndex) => {
                if (rowIndex > 0) { // ignoring the first row since it is the headera

                    const employeeExists = empList.find(emp => emp.id === parseInt(row[0]));
                    if (!employeeExists) {
                        InvalidEmployees.push(row[0]);
                        return; // Skip this row and continue with next
                    }

                    otData = {}
                    let otHours = row.slice(7)// need to develop more on this
                    otData.empId = employeeExists.value
                    otData.empName = row[1]
                    //otData.month = row[2]
                    otData.OrgUnit = costcentlist.find(cost => cost.label === row[2])?.value || row[2]
                    otData.Project = projectlist.find(proj => proj.id === row[3])?.value || row[3] 
                    otData.Remark = row[4]
                    otData.month = row[5]
                    otData.year = row[6]
                    //otData.year = row[3]
                    otData.hours = otDays.map((day, i) => [day, otHours[i]+""])
                    
 
                    empOtData.push(otData)
                    monthc = otData.month = row[5]
                }
            })
            
              // Show warning for invalid employees
            if (InvalidEmployees.length > 0) {
                this.growl.show({
                    severity: 'warn',
                    summary: null,
                    detail: `Warning: The following employee IDs are not found in employee master list: ${[...new Set(InvalidEmployees)].join(', ')}`
                });
            }



        if (empOtData) {
            this.setState({ process: [], loading: true });
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (el.fieldType === '9') {
                            const container = stageField.find(_ => _.fieldType === '9');
                            const name = container.fieldName;
                            const fields = stageField.filter(_ => _.parentFieldId === name);

                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));

                            let selEmployees = empOtData;
                            if (selEmployees && selEmployees.length > 0) {
                                let loopIndex = 0;

                                selEmployees.forEach(sel => {
                                    var { empId, month, year, hours,CostCenter,Project,Remark,OrgUnit } = sel
                                    monthc = month;

                                    hours.forEach((otDetails) => {
                                        const [otDay, otHours] = otDetails
                                        if (parseInt(monthc) != parseInt(month))
                                            {
                                                month = monthc;
                                        }
                                        
                                        fields.map((subField) => {
                                            //let formatDate = new Date(year, month, otDay);
                                            var lastdayofmonth = function(year, month){
                                                // Create a new Date object representing the last day of the specified month
                                                // By passing m + 1 as the month parameter and 0 as the day parameter, it represents the last day of the specified month
                                                return new Date(year, month , 0).getDate();
                                            }
                                            if ((parseInt(lastdayofmonth(year, month)) == parseInt(otDay)) && ((parseInt(monthc) == parseInt(month))))
                                            {
                                                monthc = parseInt(month) + 1;
                                            }
                                            
                                            let formatDate = new Date(year + "-" + month + "-" + otDay).toISOString();
                                            if (fromDate == false) {
                                                fromDate = formatDate
                                            }
                                            if (formatDate) {
                                                toDate = formatDate
                                            }
                                          
                                            a.push(Object.assign({}, { ...subField },
                                                {
                                                    childRowNmbr: loopIndex,
                                                    fieldName: `${startIndex}${count++}`,
                                                    fieldSequence: sequence++,
                                                    groupingfieldvalue: sel.empId,
                                                    stageSequence: stageIndex,
                                                    stageNum: `00${stageIndex}`,
                                                    fieldValue: (subField.fieldDescription === 'Date' && formatDate) || (subField.fieldDescription === 'Shift' && otHours) || (subField.fieldDescription === 'Cost Center' && OrgUnit) || (subField.fieldDescription === 'Project' && Project) || (subField.fieldDescription === 'Remark' && Remark) || (subField.fieldDescription === 'Employee Id' && empId) || subField.fieldValue
                                                }));

                                        });
                                        loopIndex++;
                                    })
                                });

                            }
                            this.setState({processInitiated:true});

                        }else if (el.parentFieldId === '000') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: (el.fieldDescription === "From Date" && fromDate) ||(el.fieldDescription === "Cost Center" && OrgUnit) ||(el.fieldDescription === "Project" && Project) || (el.fieldDescription === "Employees" && employees) || (el.fieldDescription === "Shift" && OTHours) || (el.fieldDescription === "To Date" && toDate) || (el.fieldDescription === "Request Date" && requestDate) || (el.fieldDescription === "OT Type" && otType) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            this.setState({processInitiated:true});
                        } 
                        return a;
                    }, [])
                })
            });

            if (InitialValues && InitialValues.length > 0) {
                
             let   InitialValuesfrd = this.setFieldValueUsingFieldidrownum("6988f945-d667-4ae7-9631-4a2af16302ac", InitialValues, fromDate, 0)
                 InitialValuesfrd = this.setFieldValueUsingFieldidrownum("31f907c9-91e6-446a-aafa-301daf59973b", InitialValuesfrd, toDate, 0)
                 InitialValuesfrd = this.setFieldValueUsingFieldidrownum("1cfc5fec-7a4e-4152-8204-d05b671a5d8e", InitialValuesfrd, OrgUnit, 0)
                 InitialValuesfrd = this.setFieldValueUsingFieldidrownum("1cfc5fec-7a4e-4152-8204-d05b671a6d8e", InitialValuesfrd, Project, 0)

           
                setTimeout(() => this.setState({ loading: false, process: InitialValuesfrd, fromDate: fromDate, toDate: toDate }), 3000);
            }
            setTimeout(this.readFromExcel.bind(this), 5000);


        } else {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

        })

    }


    }


    render() {
        const { tableLists, location = {}, keywordValuesList: empList = [] , } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, initialData,employees,fromDate, toDate, requestedFor, Project,CostCenter,OTHours,OrgUnit } = this.state;
        const tsEmpData = this.state.timesheetEmpData || []
        const tsShiftData = this.state.timesheetShiftData || []
        const pendingWith = location && location.state && location.state.pendingWith 
        const requestFrom = location && location.state && location.state.requestFrom;        

        const pageType = this.props.match.params.type;
        const status = (state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null,  DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );


        // the timesheet table rendered in html

        const ref = React.createRef(); 

        const EmployeeComponent = ({ style }) => (<div className="p-grid" style={style}>
            <div className="mt2">
                <TableContainer component={Paper}> 
                    <Table aria-label="spanning table" id="table-to-xls" ref={ref}> 
                        <TableHead className="timesheetHeader" style={{ display: 'none' }}>
                            <TableRow style={{ backgroundColor: '#bebcbc' }}>
                                <TableCell align="center" colSpan="36">TIME SHEET APPROVAL FORM</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead className="timesheetBody" style={{ display: 'none' }}>
                            {this.state.timesheetForm.map((sheet, index) =>
                                <TableRow key={index} style={{ backgroundColor: '#fff' }}>
                                    {sheet.map((c, x) =>
                                        <TableCell key={x} align="center" colSpan={x % 2 === 0 ? "2" : "7"}>{c}</TableCell>
                                    )}
                                </TableRow>
                            )}
                        </TableHead>
                        {tsEmpData.map((list, index) => {

                            const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years, WorkingHours, OTHours, otph } = tsEmpData[0];
                            const ViewList = tsShiftData;

                            return (<Table>
                                <TableHead className="timesheetHeader">
                                    <TableRow style={{ backgroundColor: '#bebcbc' }}>
                                        <TableCell align="center">SNo</TableCell>
                                        <TableCell align="center">Emp No</TableCell>
                                        <TableCell align="center" colSpan="8">Name</TableCell>
                                        <TableCell align="center" colspan="9">Position</TableCell>
                                        <TableCell align="center" colSpan="9">Department</TableCell>
                                        <TableCell align="center" colSpan="4">Employee Type</TableCell>
                                        <TableCell align="center" colSpan="2">Month</TableCell>
                                        <TableCell align="center" colSpan="2">Year</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="timesheetBody">
                                    <TableRow>
                                        <TableCell align="center">{EMPLOYEE_NO && '1' || null}</TableCell>
                                        <TableCell align="center">{EMPLOYEE_NO}</TableCell>
                                        <TableCell align="center" colSpan="8">{EmployeeName}</TableCell>
                                        <TableCell align="center" colSpan="9">{POSITION}</TableCell>
                                        <TableCell align="center" colSpan="9">{DEPARTMENT}</TableCell>
                                        <TableCell align="center" colSpan="4">{EMPLOYEETYPE}</TableCell>
                                        <TableCell align="center" colSpan="2">{Month1}</TableCell>
                                        <TableCell align="center" colSpan="2">{Years}</TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableHead className="timesheetHeader">
                                    <TableRow style={{ backgroundColor: '#a1a1a1' }}>
                                        <TableCell align="center" colSpan="33">{Month1}</TableCell>
                                        <TableCell align="center" colSpan="3">Overtime</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead className="timesheetHeader">
                                    <TableRow style={{ backgroundColor: '#cac9c9' }}>
                                        <TableCell colSpan="2">&nbsp;</TableCell>
                                        {ViewList.map((el, index) => <TableCell key={index} align="center">{el.ShiftDate && moment(el.ShiftDate).format('DD') || null}</TableCell>)}
                                        <TableCell align="center">Total</TableCell>
                                        <TableCell align="center">Pre-Approval</TableCell>
                                        <TableCell align="center">TA Report</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className="timesheetBody1">
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'darkblue', color: '#fff' }}>Shift</TableCell>
                                        {ViewList.map((fe, index) => <TableCell key={index} align="center">{fe.ShiftName}</TableCell>)}
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ fontWeight: 'bold' }}>Working Hours</TableCell>
                                        {ViewList.map((se, index) => <TableCell key={index} align="center">{se.WorkingHours}</TableCell>)}
                                        <TableCell align="center">{WorkingHours}</TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'orange', fontWeight: 'bold' }}>Late IN / Early Out</TableCell>
                                        {ViewList.map((te, index) => <TableCell key={index} align="center">{te.LateInHours && te.LateInHours.toFixed(2) || ''}</TableCell>)}
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align="center" colSpan="2" style={{ background: 'red', fontWeight: 'bold', color: '#fff' }}>OT</TableCell>
                                        {ViewList.map((fe, index) => <TableCell key={index} align="center">{fe.OTHours && fe.OTHours.toFixed(2) || ''}</TableCell>)}
                                        <TableCell align="center">{OTHours}</TableCell>
                                        <TableCell align="center">{otph && otph != null && otph.toFixed(2)}</TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>)
                        })}

                    </Table>
                </TableContainer>
            </div>
        </div>
        )

        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Work Schedule
                            <Link to={'/work-schedule'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>

                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    const containers = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId != '000'), 'groupingfieldvalue'));
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                            {stageIndex === 0 ? 
                                <div className="p-col-12">
                                    <div className="p-col-12">
                                        <input type="file" name="employeesAttachment" id="bulkUploadFile" className="inputfile inputfile-6 " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"  onChange={(e) => {
                                        const file = e.target.files[0];
                                        this.readFromExcel(file, this.state.initialData);
                                        }}/>
                                        <label htmlFor="bulkUploadFile"><span></span> <strong><img src={UploadImage} alt="upload im" /> Upload Work Schedule File&hellip;</strong></label>                         
                                    </div>
                                    <div className="p-col-3">
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.downloadOtTemplate()} label="Download WS Template" icon="pi pi-download" />
                                    </div> 
                                </div> : null}
                                {stageField.filter(_ => _.parentFieldId === '000').map((field, fieldIndex) => {
                                    return <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" || fieldIndex === 0 ? "p-col-12" : field.fieldDescription === 'To Date' ? "p-col-12 p-md-8 p-lg-8" : field.fieldDescription === 'From Date' ? "p-col-12 p-md-4 p-lg-4" : field.parentFieldId !== '000' ? "p-col-12 p-md-3 p-lg-3" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldDescription === 'To Date' ? <div className="p-grid">
                                            <div className="p-col-12 p-md-6 p-lg-6">
                                                <Inputs
                                                    field={field}
                                                    value={field.fieldValue}
                                                    process={process}
                                                    onInputChange={(e) => this.handleChange(e, field)}
                                                    {...this.props}
                                                    {...this.state} />
                                            </div>
                                            <div className="noLableMargin p-col-12 p-md-6 p-lg-6" style={{ marginTop: '2.9em' }}>
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.initialize(initialData, 'progress')} label="Initiate Process" icon="pi pi-upload" /> 
                                                <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.initialize(initialData, 'add')} className="ml1 p-button-info" label="Reset" icon="pi pi-refresh" />
                                            </div>
                                        </div> : <Inputs
                                                field={field}
                                                value={(field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',')) || (field.fieldDescription === "Employees" && employees && employees.length > 0 && employees.split(',')) || field.fieldDescription === 'From Date' && !field.fieldValue && fromDate || field.fieldDescription === 'To Date' && !field.fieldValue && toDate || field.fieldDescription === 'Project' && !field.fieldValue && Project|| field.fieldDescription === 'Cost Center' && !field.fieldValue && OrgUnit || field.fieldValue}
                                                process={process}
                                                onInputChange={(e) => this.handleChange(e, field)}
                                                {...this.props}
                                                {...this.state} />}
                                    </div>

                                })}

                                {/* INSERTED BY ABU 15 11 */}
                                {this.state.processInitiated && 
                                <Accordion activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange.bind(this)}>
                                    {Object.keys(containers).map((emp, empIndex) => {
                                        const EmployeeField = containers[emp];
                                        const selEmployeeDet = empList.find(_ => _.value === emp) || {};
                                        const totalHours = EmployeeField.reduce((a, el) => el.fieldDescription === 'Hours' && el.fieldValue ? a + parseInt(el.fieldValue) : a, 0);
                                        const Accemp = EmployeeField.reduce((a, el) => el.fieldDescription === 'Employees' && el.fieldValue ? el.fieldValue: a, '');
                                        //const usedhour = this.fusedhour(emp);
                                        //return <AccordionTab key={empIndex} header={`${selEmployeeDet.label} (Total Hours - ${totalHours})`}>
                                        return <AccordionTab key={empIndex} header={`${selEmployeeDet.label} `}>
                                            <div className="p-grid">
                                                {EmployeeField.map((field, fieldIndex) => {
                                                    return <div key={fieldIndex} className={"p-col-12 p-md-2 p-lg-2"} >
                                                        <Inputs
                                                            field={field}
                                                            value={field.fieldDescription === "Employees" && field.fieldValue && field.fieldValue.split(',') || field.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, field)}
                                                            {...this.props}
                                                            {...this.state} />
                                                    </div>
                                                })}
                                            </div>
                                        </AccordionTab>
                                    })}
                                </Accordion>}

                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'OTPreApproval'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}

                                {/* END INSERT */}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) != stageIndex && pendingWith !== null) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Link to={'/work-schedule'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        {this.state.processInitiated && 
                                            <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed') ? true : false} onClick={() => this.showPreview()} className="p-button-success ml1" label="PreView TImesheet" icon="pi pi-eye" />
                                        }
                                        <Button disabled={status && status === 'Closed' && pendingWith !== null ? false : true} className="p-button-danger ml1" label="Cancel" style={{marginRight:'10px'}} onClick={() => this.saveRequest('cancel')} />
                                        <Link to={'/work-schedule'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}



                
                {!this.state.timesheetPreview ? <EmployeeComponent style={{ display: 'none' }} /> : null}
                <Dialog header="PreView Timesheet" className="timesheetModal" visible={this.state.timesheetPreview} modal={true} onHide={() => this.setState({ timesheetPreview: false, expandedRows: false })}>
                    <EmployeeComponent />
                </Dialog>
                
                              


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }
}

const mapStateToProps = (state, props) => {
    
    const pageType = props.match.params.type;
   // const costcentlist = props.keyword.CostCenter.map(el => Object.assign({}, { label: el.label, value: el.value,id: el.id }));
   // const projectlist = props.keyword.Project.map(el => Object.assign({}, { label: el.label, value: el.value,id: el.id }));
    const emplist = state?.master?.keywordValuesList?.map(e => ({...e, value:e.uniqueId})) || []
    const subordinatesList = pageType === 'edit' && state.master.requestAttributeData  ? ([Object.assign({}, { label: `${state.master.requestAttributeData.employeename} (Self)`, value: state.master.requestAttributeData.employeeID })]).concat(state.master.subordinatesListData) : ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const shiftPatternList = state.master.shiftPatternData.map(el => Object.assign({}, { label: el.name, value: el.id.toString() }));
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, {...el}, {value: el.uniqueId}));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), {label: `${state.auth.userObject.userName}-Self`, value:state.auth.userObject.empID , id: parseInt(state.auth.userObject.userID)})]);
    
    return {
        loggedUserDetail: state.auth.userObject,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        subordinatesListData: state.master.subordinatesListData,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        shiftPatternData: state.master.shiftPatternData,
        keywordValuesList,
        employeeWorkSheetData: state.master.employeeWorkSheetData,
        metaData: Object.assign({}, {
            'Shift': state.keyword.Shift,
            'Shift Pattern': shiftPatternList,
            'Cost Center': state.keyword.OrgUnit,
            'Project': state.keyword.Project,
            'Employees': emplist,
            'Employee Id': emplist,
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        getShiftPatternData: () => dispatch(actions.getShiftPatternData()),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data)),
        getEmployeeWorkSheetData: (data) => dispatch(actions.getEmployeeWorkSheetData(data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ShiftApproval);